import {
  Button,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper
} from "@material-ui/core";
import React from "react";

export interface DropOffSearchFilterProps {
  keyId: string;
  options: string[];
  handleChange: (ev: any) => void;
}

const DropOffSearchFilter: React.FC<DropOffSearchFilterProps> = props => {
  const { keyId, options, handleChange } = props;

  const [open, setOpen] = React.useState(false);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [anchorRef, setAnchorRef] = React.useState<HTMLElement | null>(null);

  const handleToggle = () => {
    setAnchorRef(document.getElementById(`btn${keyId}`));
    setOpen(prevOpen => !prevOpen);
  };

  const handleMenuItemClick = (
    _event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number
  ) => {
    setSelectedIndex(index);
    handleChange(index);
    setOpen(false);
  };

  const handleClose = (event: React.MouseEvent<Document, MouseEvent>) => {
    if (anchorRef?.contains(event.target as HTMLElement)) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <Button
        id={"btn" + keyId}
        variant="outlined"
        color="primary"
        size="large"
        aria-controls={open ? "dropoff-filter-button-menu" + keyId : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-label="Filter"
        aria-haspopup="menu"
        onClick={handleToggle}
        style={{
          height: "50px"
        }}
      >
        Filter
      </Button>
      <Popper
        id={"pop" + keyId}
        open={open}
        anchorEl={anchorRef}
        placement="bottom-end"
        transition
        style={{
          zIndex: 1301
        }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id={"dropoff-filter-button-menu" + keyId}>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option}
                      selected={index === selectedIndex}
                      onClick={event => handleMenuItemClick(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

DropOffSearchFilter.displayName = "DropOffSearchFilter";
export default DropOffSearchFilter;
